/**
 *   vjs form
 */
!(function(a) {
	a.fn.vjs_form = function(b) {
		var c = this,
			d = {};
		return (
			(b = b ? b : {}),
			(d.message = ""),
			(d.init = function() {
				return d.removeErrorClass(), !!(("undefined" != typeof b.validation && b.validation === !1) || d.validate()) && d.buildObject();
			}),
			(d.validate = function() {
				var b = !0;
				return (
					c.find(".vjs-input.vjs-validate").each(function(c) {
						var f,
							e = a(this),
							g = e.attr();

						if (((f = e.is("input") || e.is("select") || e.is("textarea") ? a.trim(e.val()) : a.trim(e.attr("value"))), "" === f)) {
							return !e.hasClass("vjs-required") || (d.setErrorMessage("field is required."), d.error(e), (b = !1));
						}

						for (var h in g) if (g.hasOwnProperty(h) && d.test[h] && !d.test[h](f, g[h], e)) return d.error(e), (b = !1);
					}),
					b
				);
			}),
			(d.buildObject = function() {
				var b = {},
					d = !1;
				return (
					c.find(".vjs-input").each(function() {
						var e,
							c = a(this);

						(e =
							!c.is(":checkbox") || (void 0 !== c.attr("value") && "on" !== c.attr("value"))
								? c.is("input") || c.is("select") || c.is("textarea") ? a.trim(c.val()) : a.trim(c.attr("value"))
								: c.is(":checked") ? 1 : 0),
							"" === e && c.is("[vjs-default]") && (e = c.attr("vjs-default")),
							c.is("textarea") ? (b[c.attr("name")] = encodeURIComponent(e)) : (b[c.attr("name")] = e),
							(d = !0);
					}),
					d ? b : (console.log("The form object is empty."), !1)
				);
			}),
			(d.error = function(a) {
				var c = a.is("[vjs-message]") ? a.attr("vjs-message") : "invalid field";
				d.removeErrorClass(), a.addClass("vjs-error"), b.error && "function" == typeof b.error ? b.error(c + " - " + d.message) : alert(c + " - " + d.message);
			}),
			(d.removeErrorClass = function() {
				a(".vjs-error").removeClass("vjs-error");
			}),
			(d.test = {
				"vjs-length": function(a, b) {
					if (/[,]/g.test(b)) {
						b = b.split(",");
						for (var c = 0; c < b.length; c++) if (((b[c] = parseInt(b[c])), a.length === b[c])) return !0;
						return d.setErrorMessage("incorrect length"), !1;
					}
					return a.length === parseInt(b) || (d.setErrorMessage("incorrect length"), !1);
				},
				"vjs-type": function(a, b, c) {
					if ("number" === b) return !!/^\d+$/g.test(a) || (d.setErrorMessage("incorrect type - must be a number"), !1);
					if ("phone" === b) return a.is("phone") ? (c.val(a.prep("phone")), !0) : (d.setErrorMessage("incorrect phone format"), !1);
					if ("money" === b) return !!/^\d+$/g.test(a) || (d.setErrorMessage("incorrect type - must be a number"), !1);
					if ("email" === b) return !!a.is("email") || (d.setErrorMessage("incorrect email format"), !1);
					if ("url" === b) {
						if (a.is("url")) return !0;
						d.setErrorMessage("incorrect url format");
					}
				},
				"vjs-length-range": function(a, b) {
					return /[,]/g.test(b)
						? ((b = b.split(",")),
							(a.length >= parseInt(b[0]) && a.length <= parseInt(b[1])) ||
								(d.setErrorMessage("invalid input - the field length must be between " + b[0] + " and " + b[1]), !1))
						: (a.length >= 0 && a.length <= parseInt(b)) || (d.setErrorMessage("invalid input - the field length must be between 0 and " + b), !1);
				},
				"vjs-number-range": function(a, b) {
					return /[,]/g.test(b)
						? ((b = b.split(",")),
							(parseInt(a) >= parseInt(b[0]) && parseInt(a) <= parseInt(b[1])) ||
								(d.setErrorMessage("invalid input - the number must be between " + b[0] + " and " + b[1]), !1))
						: (parseInt(a) >= 0 && parseInt(a) <= parseInt(b)) || (d.setErrorMessage("invalid input - the number must be between 0 and " + b[0]), !1);
				},
				"vjs-match": function(b, c, e) {
					var f = a(c)
							.map(function() {
								return a(this).val();
							})
							.get(),
						g = f.every(function(a) {
							return a === f[0];
						});
					return !!g || (d.setErrorMessage("the fields do not match"), !1);
				}
			}),
			(d.setErrorMessage = function(a) {
				d.message = a;
			}),
			d.init()
		);
	};
})($);

!(function(a) {
	a.fn.vjs_dform = function(b) {
		var c = this,
			d = {};
		return (
			(b = b ? b : {}),
			(d.message = ""),
			(d.init = function() {
				return d.removeErrorClass(), !!(("undefined" != typeof b.validation && b.validation === !1) || d.validate()) && d.buildObject();
			}),
			(d.validate = function() {
				var b = !0;
				return (
					c.find(".vjs-input.vjs-validate").each(function(c) {
						var f,
							e = a(this),
							g = e.attr();

						if (!e.is(":visible")){ // do not validate invisible inputs
							return;
						}

						if (((f = e.is("input") || e.is("select") || e.is("textarea") ? a.trim(e.val()) : a.trim(e.attr("value"))), "" === f)) {
							return !e.hasClass("vjs-required") || (d.setErrorMessage("field is required."), d.error(e), (b = !1));
						}

						for (var h in g) if (g.hasOwnProperty(h) && d.test[h] && !d.test[h](f, g[h], e)) return d.error(e), (b = !1);
					}),
					b
				);
			}),
			(d.buildObject = function() {
				var b = {},
					d = !1;
				return (
					c.find(".vjs-input").each(function() {
						var e,
							c = a(this);

						if ('hidden' != c.attr('type') && c.is(':not(:visible)')) {
							return;
						}

						(e =
							!c.is(":checkbox") || (void 0 !== c.attr("value") && "on" !== c.attr("value"))
								? c.is("input") || c.is("select") || c.is("textarea") ? a.trim(c.val()) : a.trim(c.attr("value"))
								: c.is(":checked") ? 1 : 0),
							"" === e && c.is("[vjs-default]") && (e = c.attr("vjs-default")),
							c.is("textarea") ? (b[c.attr("name")] = encodeURIComponent(e)) : (b[c.attr("name")] = e),
							(d = !0);
					}),
					d ? b : (console.log("The form object is empty."), !1)
				);
			}),
			(d.error = function(a) {
				var c = a.is("[vjs-message]") ? a.attr("vjs-message") : "invalid field";
				d.removeErrorClass(), a.addClass("vjs-error"), b.error && "function" == typeof b.error ? b.error(c + " - " + d.message) : alert(c + " - " + d.message);
			}),
			(d.removeErrorClass = function() {
				a(".vjs-error").removeClass("vjs-error");
			}),
			(d.test = {
				"vjs-length": function(a, b) {
					if (/[,]/g.test(b)) {
						b = b.split(",");
						for (var c = 0; c < b.length; c++) if (((b[c] = parseInt(b[c])), a.length === b[c])) return !0;
						return d.setErrorMessage("incorrect length"), !1;
					}
					return a.length === parseInt(b) || (d.setErrorMessage("incorrect length"), !1);
				},
				"vjs-type": function(a, b, c) {
					if ("number" === b) return !!/^\d+$/g.test(a) || (d.setErrorMessage("incorrect type - must be a number"), !1);
					if ("phone" === b) return a.is("phone") ? (c.val(a.prep("phone")), !0) : (d.setErrorMessage("incorrect phone format"), !1);
					if ("money" === b) return !!/^\d+$/g.test(a) || (d.setErrorMessage("incorrect type - must be a number"), !1);
					if ("email" === b) return !!a.is("email") || (d.setErrorMessage("incorrect email format"), !1);
					if ("url" === b) {
						if (a.is("url")) return !0;
						d.setErrorMessage("incorrect url format");
					}
				},
				"vjs-length-range": function(a, b) {
					return /[,]/g.test(b)
						? ((b = b.split(",")),
							(a.length >= parseInt(b[0]) && a.length <= parseInt(b[1])) ||
								(d.setErrorMessage("invalid input - the field length must be between " + b[0] + " and " + b[1]), !1))
						: (a.length >= 0 && a.length <= parseInt(b)) || (d.setErrorMessage("invalid input - the field length must be between 0 and " + b), !1);
				},
				"vjs-number-range": function(a, b) {
					return /[,]/g.test(b)
						? ((b = b.split(",")),
							(parseInt(a) >= parseInt(b[0]) && parseInt(a) <= parseInt(b[1])) ||
								(d.setErrorMessage("invalid input - the number must be between " + b[0] + " and " + b[1]), !1))
						: (parseInt(a) >= 0 && parseInt(a) <= parseInt(b)) || (d.setErrorMessage("invalid input - the number must be between 0 and " + b[0]), !1);
				},
				"vjs-match": function(b, c, e) {
					var f = a(c)
							.map(function() {
								return a(this).val();
							})
							.get(),
						g = f.every(function(a) {
							return a === f[0];
						});
					return !!g || (d.setErrorMessage("the fields do not match"), !1);
				}
			}),
			(d.setErrorMessage = function(a) {
				d.message = a;
			}),
			d.init()
		);
	};
})($);

/**
 *   vjs attr
 *     - addition to the .attr function, if you call it without any parameters it will
 *     return all the attributes as an object
 */
!(function(a) {
	$.fn.attr = function() {
		if (0 === arguments.length) {
			if (0 === this.length) return null;
			var b = {};
			return (
				$.each(this[0].attributes, function() {
					this.specified && (b[this.name] = this.value);
				}),
				b
			);
		}
		return a.apply(this, arguments);
	};
})($.fn.attr);

(function() {
	//
	// Turn on tooltips
	//
	$(document).ready(function() {
		$('[data-toggle="tooltip"]').tooltip();
	});

	/**
	 *   Handle the hashtag sliding on page load
	 */
	$(document).ready(function() {
		if (!window.location.hash) return;
		slider.slide(window.location.hash);
	});

	/**
	 *   Clicking the subheadings
	 */
	$("body").on("click", ".subnav-link-items", function(e) {
		var $me = $(this);
		if ($me.hasClass("normal-link")) {
			return;
		}
		e.preventDefault();
		slider.slide($me.attr("href"));
	});

	$('#toggle-responsive-nav').on('click', function (e) {
		$('nav').find('ul.nav').toggleClass('is-active');
	})
	/**
	 *   Clicking the main header links to get scroll action to internal links
	 */

	$("body").on("click", ".navbar-fixed-top .subnav-links", function(e) {
		var $me = $(this);
		if ($me.hasClass("normal-link")) {
			return;
		}
		// get URL and see if already on customers page
		// get parent nav bar so you can get section attr to check against path
		// if not on same page as 'section' attr, navigate to page normally
		// else prevent default and use slide
		var location = window.location;
		var parentNavBar = $me.parents(".navbar-fixed-top");
		if (location.pathname.indexOf(parentNavBar.attr("section")) == -1) return;
		e.preventDefault();
		slider.slide(
			// added separate 'slideTarget' attribute instead of href since these have to work from other pages
			// slideTarget just looks like a regular internal href link
			$me.attr("slideTarget")
		);
	});

	/**
	 *   Hashtag Slider
	 */
	var slider = {
		slide: function(hashtag) {
			//find distance to top of page
			var top = $(hashtag).position().top - 60,
				distance = Math.abs(top - $("body").scrollTop());
			this.animate(top, distance);
		},
		animate: function(to, distance) {
			$("html, body").animate({ scrollTop: to }, "slow");
		}
	};

	//
	// Animate the scroll to top
	//
	$("body").on("click", ".go-top", function(e) {
		e.preventDefault();
		slider.animate(0);
	});

	//
	// navbar change color on scroll
	//

	$(document).on("scroll", function() {
		// get distance to top
		var top = $(this).scrollTop();
		// when distance becomes greater than 150px
		if (top > 150) {
			// change navbar to purple
			$("#main-navbar").addClass("navbar-color-change");
		} else {
			// if it goes back, then remove purple
			$("#main-navbar").removeClass("navbar-color-change");
		}

		// when distance becomes greater than 400px
		if (top > 1200) {
			// show the 'go to top' button
			$(".go-top").addClass("show-go-top");
		} else {
			// or hide 'go to top' button
			$(".go-top").removeClass("show-go-top");
		}
	});

	//
	// nav subnav display
	//

	// when user hovers a main top nav link
	$(".main-top-links").mouseenter(function() {
		// if on mobile then jquery element will return here so this behavior doesnt work on mobile
		var mobile = $(this).closest(".in");
		// returns here vvv if mobile vvv
		if (mobile.hasClass("in")) {
			return;
		} else {
			//if NOT mobile, then get the 'subnavtarget' attr of whichever link user is hovering over and set as var target
			var target = $(this).attr("subnavtarget");
			if (!target) return;

			// remove active class from all other nav links
			$.each($(".main-top-links"), function(i, val) {
				$(this).removeClass("active");
			});
			// add active class to link being hovered over
			$(this).toggleClass("active");
			// *** IMPORTANT
			// the target has the 'active' class toggled this HIDES / SHOWS the subnav navbar underneath the main nav (this is reversed below)
			$("#" + target).toggleClass("active");
		}
	});

	// when user stops hovering over main nav link
	$(".main-top-links").mouseleave(function() {
		// get subnavtarget attr of item being hovered
		var target = $(this).attr("subnavtarget");

		// if .main-top-links does not have a subnav and mouse leaves, remove active class (e.g. contact, schedule demo links)
		if (!target) {
			$(this).removeClass("active");
		}
		// *** IMPORTANT
		// the target has the 'active' class toggled this HIDES / SHOWS the subnav navbar underneath the main nav (this is reversed above)
		$("#" + target).toggleClass("active");
	});

	// when hovered over a SUBNAV navbar
	// keeps that subnav bar open
	$(".sub-navbar.header").mouseenter(function() {
		var target = $(this).attr("subnavtarget");
		$(this).addClass("active");
	});

	// when user leaves SUBNAV navbar, clear active class from TOPNAV links and also from the subnav navbar
	$(".sub-navbar.header").mouseleave(function() {
		$(this).removeClass("active");
		$.each($(".main-top-links"), function(i, val) {
			$(this).removeClass("active");
		});
	});

	// MOBILE ONLY
	// This toggles the resources icon between a plus and a minus
	$(".main-top-links.resources").click(function() {
		$(".resource-plus").toggleClass("fa-plus fa-minus");
	});

	$(".main-top-links.products").click(function() {
		$(".products-plus").toggleClass("fa-plus fa-minus");
	});

	//
	//
	// HOME PAGE WISTIA VIDEOS HOVER
	//
	$(".career-video-thumbnail-container").mouseenter(function() {
		$(this)
			.find(".homepage-wistia-play-btn-bg")
			.addClass("active");
	});

	$(".career-video-thumbnail-container").mouseleave(function() {
		$(this)
			.find(".homepage-wistia-play-btn-bg")
			.removeClass("active");
	});

	//
	//
	// HOME PAGE WISTIA VIDEOS MODALS
	//
	// main homepage video
	$(".jumbotron-homepage-play-button").click(function(e) {
		var target = $(e.currentTarget).attr("wistia-target");
		console.log(target);
		var modal = $("#main-video-modal-template");
		var modalBody = $("#main-video-modal-template .modal-body");
		modalBody.html("<div class='wistia_embed wistia_async_" + target + " videoFoam=true playerColor=54bbff'style='width:100%;height:100%;''>&nbsp;</div>");
		$(modal).modal("show");
	});

	// homepage video button links
	$(".homepage-jumbotron-video-buttons").click(function(e) {
		e.preventDefault();
		var target = $(e.currentTarget).attr("wistia-target");
		console.log(target);
		var modal = $("#main-video-modal-template");
		var modalBody = $("#main-video-modal-template .modal-body");
		modalBody.html("<div class='wistia_embed wistia_async_" + target + " videoFoam=true playerColor=54bbff'style='width:100%;height:100%;''>&nbsp;</div>");
		$(modal).modal("show");
	});

	// 4 career videos
	$(".engaging-video-container .career-video-thumbnail-container").click(function(e) {
		var target = $(e.currentTarget).attr("wistia-target");
		console.log(target);
		var modal = $("#career-video-modal-template");
		var modalBody = $("#career-video-modal-template .modal-body");
		modalBody.html("<div class='wistia_embed wistia_async_" + target + " videoFoam=true playerColor=54bbff'style='width:100%;height:100%;''>&nbsp;</div>");
		$(modal).modal("show");
	});

	// Homepage carousel videos
	$(".carousel .career-video-thumbnail-container").click(function(e) {
		var target = $(e.currentTarget).attr("wistia-target");
		if (!target) {
			return;
		}
		var modal = $("#career-video-modal-template");
		var modalBody = $("#career-video-modal-template .modal-body");
		modalBody.html("<div class='wistia_embed wistia_async_" + target + " videoFoam=true playerColor=54bbff'style='width:100%;height:100%;''>&nbsp;</div>");
		$(modal).modal("show");
	});

	// career exploration video
	$(".video-jumbotron-play-button").click(function(e) {
		var target = $(e.currentTarget).attr("wistia-target");
		console.log(target);
		var modal = $("#career-exploration-video-modal-template");
		var modalBody = $("#career-exploration-video-modal-template .modal-body");
		modalBody.html("<div class='wistia_embed wistia_async_" + target + " videoFoam=true playerColor=54bbff'style='width:100%;height:100%;''>&nbsp;</div>");
		$(modal).modal("show");
	});

	//
	// Expand Learn More button
	//
	$(".expand-btn").click(function(e) {
		e.preventDefault();
		var target = $(this).attr("expandtarget");
		$("#" + target).toggleClass("hidden-xs");
	});

	// Formats users phone input to automatically insert dashes at carrect locations
	// $('.phone-input').on('blur', function(e) {
	//     var input = $(e.currentTarget)[0];
	//     input.value = input.value.slice(0, 3) + "-" + input.value.slice(3, 6) + "-" + input.value.slice(6, 10);
	// });

	// FAQ PAGE

	$(".faq-plus").on("click", function(e) {
		var clickTarget = $(e.currentTarget);
		var parentContainer = clickTarget.parents(".mobile-glossary-questions-container");
		var answerTarget = parentContainer.find(".glossary-answers.mobile");

		parentContainer.find(".faq-minus").show();
		clickTarget.hide();
		answerTarget.show();
	});

	$(".faq-minus").on("click", function(e) {
		var clickTarget = $(e.currentTarget);
		var parentContainer = clickTarget.parents(".mobile-glossary-questions-container");
		var answerTarget = parentContainer.find(".glossary-answers.mobile");

		parentContainer.find(".faq-plus").show();
		clickTarget.hide();
		answerTarget.hide();
	});

	// Career Exploration Course Page
	$(document).ready(function() {
		$("#career-exploration-course-carousel").on("init", function(slick) {
			$(".slick-slide[data-slick-index='0']")
				.prev()
				.addClass("previous-slide");
			$(".slick-slide[data-slick-index='0']")
				.next()
				.addClass("next-slide");
		});

		$("#career-exploration-course-carousel").slick({
			centerMode: true,
			slidesToShow: 5,
			prevArrow: $(".prev"),
			nextArrow: $(".next"),
			cssEase: "ease",
			infinite: true,
			speed: 700,
			responsive: [
				{
					breakpoint: 1140,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});

		$("#career-exploration-course-carousel").on("beforeChange", function(event, slick, currentSlide, nextSlide) {
			$(".slick-slide").removeClass("previous-slide next-slide");

			$(".slick-slide[data-slick-index=" + nextSlide + "]")
				.prev()
				.addClass("previous-slide");
			$(".slick-slide[data-slick-index=" + nextSlide + "]")
				.next()
				.addClass("next-slide");
		});

		$(".quotee-face").click(function(e) {
			$(".quote-container").removeClass("active");
			var quoteTarget = $(e.currentTarget).data("quote");
			$(".quote-container[data-quote=" + quoteTarget + "]").addClass("active");
		});
	});
})();

/**
 *   Schedule Demo
 */
(function() {
	var self = {};

	self.requestDemoModal = function(e) {
		e.preventDefault();
		var $form = $("#schedule-demo-form"),
			post = $form.vjs_form();
		if (!post) return;

		// setting url for diagnostics and analyzing trends of form submissions
		$("#url").val(window.location.pathname);

		$form.submit();
		$("#schedule-demo-modal").modal("hide");
		$form[0].reset();
	};

	self.customerTrainingModal = function(e) {
		e.preventDefault();
		$("#customer-training-alert").addClass("hide");

		var post = $("#customer-training-form").vjs_form();
		if (!post) return;

		$.post("/prelogin/forms/customertraining/", post)
			.done(function(res) {
				if (res.success) {
					$("#training-modal").modal("hide");
					window.open("/scheduledemo/thank-you-training/");
				}
			})
			.fail(function() {
				$("#customer-training-alert").removeClass("hide");
			});
	};

	self.contactForm = function(e) {
		e.preventDefault();
		var $form = $("#contact-form"),
			post = $form.vjs_form();

		// setting url for diagnostics and analyzing trends of form submissions
		$("#url").val(window.location.pathname);

		if (!post) return;
		$form.submit();
	};

	self.setScheduleDemoModal = function(e) {
		e.preventDefault();

		// if on homepage dont try and grab user's name fields
		// just grab email and insert into modal
		if ($("#schedule-demo-quick-email-homepage").val()) {
			var emailHomepage = $("#schedule-demo-quick-email-homepage").val();
			$("#schedule-demo-email").val(emailHomepage);
		} else {
			// otherwise grab all data, format name, and insert into modal
			var email = $("#schedule-demo-quick-email").val(),
				name = $("#schedule-demo-quick-name").val(),
				firstName = "",
				lastName = "",
				temp;

			if (name.indexOf(" ") !== -1) {
				temp = name.split(" ");
				firstName = temp[0];
				lastName = temp[1];
			} else {
				firstName = name;
			}

			//put values in the modal
			$("#schedule-demo-first-name").val(firstName);
			$("#schedule-demo-last-name").val(lastName);
			$("#schedule-demo-email").val(email);
		}
	};

	//Events
	
	$("#customer-training-button").on("click", self.customerTrainingModal);
})();


$(document).ready(function(){
	$('#login-button').parents('form').submit(function(e) {
		if ('true' == $(e.currentTarget).attr('submitted')) {
			e.preventDefault();
			return false;
		}
		$(e.currentTarget).attr('submitted', true);
	});
});